/* THE SUMMIT — Phase 4: card quick-add (AJAX + Dawn drawer/toast) and compact sticky collections bar */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-tsdv-quickadd]')) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]');
    if (btn) btn.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData(f);
    var body = { items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }] };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { if (window.TsdvUI && TsdvUI.toast) TsdvUI.toast.show(res.description || res.message || 'Unavailable'); return; }
      if (drawer && res.sections && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: body.items[0].id, sections: res.sections }); }
      else location.href = (window.routes && window.routes.cart_url) || '/cart';
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tsdv-quickadd', productVariantId: body.items[0].id });
    }).catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-busy'); });
  });

  var sec = document.querySelector('.tsdv-cbar-section');
  var bar = sec && sec.querySelector('.tsdv-cbar');
  if (bar) {
    var s = document.createElement('i');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'display:block;height:0;pointer-events:none';
    sec.parentNode.insertBefore(s, sec);
    var raf = 0;
    /* keep the section's flow height so the page does not jump when the bar slims down */
    var lock = function () { if (!bar.classList.contains('is-stuck')) { sec.style.minHeight = ''; sec.style.minHeight = sec.offsetHeight + 'px'; } };
    lock();
    var check = function () {
      raf = 0;
      var top = parseFloat(getComputedStyle(sec).top) || 0;
      bar.classList.toggle('is-stuck', s.getBoundingClientRect().top < top - 4);
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    window.addEventListener('resize', function () { lock(); check(); });
    check();
  }
})();
